var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/ViewPort/index.js";
import React from 'react';
import pt from 'prop-types';

const ViewPort = ({
  width,
  offset,
  children
}) => /*#__PURE__*/React.createElement("svg", {
  width: `${width}%`,
  height: "100%",
  x: `${offset}%`,
  y: "0",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 9,
    columnNumber: 3
  }
}, children);

ViewPort.propTypes = {
  width: pt.number.isRequired,
  offset: pt.number.isRequired,
  children: pt.node
};
ViewPort.defaultProps = {
  children: /*#__PURE__*/React.createElement("g", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 13
    }
  })
};
export default ViewPort;
